import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_BASE_URL + "/admin";

export default function AdminUserManagement() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);

  const [form, setForm] = useState({
    userId: "",
    empName: "",
    role: "",
    password: "",
    isActive: 1
  });

  /* =========================
     LOAD USERS + ROLES
  ========================= */
  useEffect(() => {
    loadUsers();
    loadRoles();
  }, []);

  const loadUsers = async () => {
    const res = await axios.get(`${API}/users`);
    setUsers(res.data);
  };

  const loadRoles = async () => {
    const res = await axios.get(`${API}/roles`);
    setRoles(res.data);
  };

  /* =========================
     CREATE USER
  ========================= */
  const createUser = async () => {
    if (!form.userId || !form.empName || !form.role || !form.password) {
      alert("All fields are required");
      return;
    }

    try {
      await axios.post(`${API}/users`, form);
      alert("User created successfully");
      setForm({
        userId: "",
        empName: "",
        role: "",
        password: "",
        isActive: 1
      });
      loadUsers();
    } catch (err) {
      alert(err.response?.data?.message || "Create failed");
    }
  };

  /* =========================
     TOGGLE ACTIVE
  ========================= */
  const toggleActive = async (user) => {
    await axios.put(`${API}/users/${user.UserID}/active`, {
      isActive: user.EmployeeActive ? 0 : 1
    });
    loadUsers();
  };

  /* =========================
     CHANGE ROLE
  ========================= */
  const changeRole = async (userId, role) => {
    await axios.put(`${API}/users/${userId}/role`, { role });
    loadUsers();
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Admin – User Management</h2>

      {/* ================= CREATE USER ================= */}
      <div style={{ marginBottom: 20, padding: 10, border: "1px solid #ddd" }}>
        <h4>Create User</h4>

        <input
          placeholder="User ID"
          value={form.userId}
          onChange={(e) => setForm({ ...form, userId: e.target.value })}
        />

        <input
          placeholder="Employee Name"
          value={form.empName}
          onChange={(e) => setForm({ ...form, empName: e.target.value })}
          style={{ marginLeft: 5 }}
        />

        <select
          value={form.role}
          onChange={(e) => setForm({ ...form, role: e.target.value })}
          style={{ marginLeft: 5 }}
        >
          <option value="">Select Role</option>
          {roles.map((r) => (
            <option key={r.RoleName} value={r.RoleName}>
              {r.RoleName}
            </option>
          ))}
        </select>

        <input
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          style={{ marginLeft: 5 }}
        />

        <select
          value={form.isActive}
          onChange={(e) =>
            setForm({ ...form, isActive: Number(e.target.value) })
          }
          style={{ marginLeft: 5 }}
        >
          <option value={1}>Active</option>
          <option value={0}>Inactive</option>
        </select>

        <button onClick={createUser} style={{ marginLeft: 10 }}>
          Create
        </button>
      </div>

      {/* ================= USERS TABLE ================= */}
      <table width="100%" border="1" cellPadding="6">
        <thead>
          <tr>
            <th>UserID</th>
            <th>Employee Name</th>
            <th>Role</th>
            <th>Employee Active</th>
            <th>Login Active</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {users.map((u) => (
            <tr key={u.UserID}>
              <td>{u.UserID}</td>
              <td>{u.EmpName}</td>

              {/* CHANGE ROLE */}
              <td>
                <select
                  value={u.Role}
                  onChange={(e) => changeRole(u.UserID, e.target.value)}
                >
                  {roles.map((r) => (
                    <option key={r.RoleName} value={r.RoleName}>
                      {r.RoleName}
                    </option>
                  ))}
                </select>
              </td>

              <td style={{ color: u.EmployeeActive ? "green" : "red" }}>
                {u.EmployeeActive ? "Active" : "Inactive"}
              </td>

              <td style={{ color: u.LoginActive ? "green" : "red" }}>
                {u.LoginActive ? "Active" : "Inactive"}
              </td>

              <td>
                <button onClick={() => toggleActive(u)}>
                  {u.EmployeeActive ? "Deactivate" : "Activate"}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
